export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téléphone"])},
        "birth_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de naissance"])},
        "birth_place": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lieu de naissance"])},
        "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse"])}
      },
      "en": {
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone"])},
        "birth_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date of birth"])},
        "birth_place": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Place of birth"])},
        "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Address"])}
      }
    }
  })
}
